import { render } from "./TeamMessage.vue?vue&type=template&id=e25925d4"
import script from "./TeamMessage.vue?vue&type=script&lang=js"
export * from "./TeamMessage.vue?vue&type=script&lang=js"
script.render = render

export default script